//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "lodash";
const staticObj = {
	BUYER_NAME: "insur_insurinfoinput_holdername_click",
	BUYER_CARD_CODE: "insur_insurinfoinput_holderidentity_click",
	BUYER_MOBILE: "insur_insurinfoinput_holderphone_click",
	INSURED_NAME: "insur_insurinfoinput_insuredname_click",
	INSURED_CARD_CODE: "insur_insurinfoinput_insuredidentity_click",
};
export default {
	data() {
		return {};
	},
	inject: {
		staticConfig: {
			default: () => ({ ...staticObj }),
		},
	},
	props: {
		data: {
			type: Object,
			default() {
				return {
					value: element.value, //默认值
					rules: {
						max: "", //最大值
						inputLimit: [], //输入规则
					},
					elementCode: element.elementCode, //
					elementEnums: element.elementEnums, //
					ruleEnums: element.ruleEnums, //
					elementName: element.elementName,
					showName: element.showName,
					componentTypeCode: element.componentTypeCode,
					isCount: element.isCount, //是否为算费因子
					placeholder: "", //提示文字
					moduleCode: moduleCode, // 所属哪个模块
					isRequired: element.isRequired, //是否必填（可修改）
					defaultisRequired: element.defaultisRequired, //是否必填默认值
					readonly: element.readonly, //只读
				};
			},
		},
		value: {
			type: Object,
			default() {
				return {
					value: "", //默认值
				};
			},
		},
		disabled: {
			type: [Boolean],
			default: false,
		},
	},
	watch: {},
	created() {
		// 初次设置默认值 （不触发算费）
		this.data.value ? this.input(this.data.value) : this.input("");
	},
	methods: {
		scrollInto(value) {
			// 兼容app内样式问题
			window.setTimeout(function() {
				const scrollHeight =
					document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollHeight) {
					window.scrollTo(0, Math.max(scrollHeight - 1, 0));
				}
			}, 0);
			// 埋点
			if (value) {
				const elementEnums = this.data.elementEnums;
				let staticName = get(this.staticConfig, elementEnums);
				let staticFn = get(this.STATISTICS_CONFIG, staticName);
				if (!staticName || typeof staticFn !== "function") {
					staticName = get(staticObj, elementEnums);
					staticFn = get(this.STATISTICS_CONFIG, staticName);
				}
				if (typeof staticFn === "function") {
					staticFn();
				}
			}
			//失去焦点时 发出通知，请求算费结果
			let item = this.getPostData(value);
			this.$emit("change", item);
		},
		// 发送修改的值
		input(value) {
			let obj = this.getPostData(value);
			this.$emit("input", obj);
		},
		// 格式化
		getPostData(value) {
			return {
				value: value, //选中值
				rules: {
					max: this.data.rules.max,
					inputLimit: this.data.rules.inputLimit,
				},
				elementCode: this.data.elementCode, //
				elementEnums: this.data.elementEnums, //
				elementName: this.data.elementName,
				showName: this.data.showName,
				componentTypeCode: this.data.componentTypeCode,
				ruleEnums: this.data.ruleEnums, //
				isCount: this.data.isCount, //是否为算费因子
				moduleCode: this.data.moduleCode, // 所属哪个模块
				isRequired: this.data.isRequired, //是否必填
				defaultisRequired: this.data.defaultisRequired, //是否必填默认值
				readonly: this.data.readonly, //只读
			};
		},
	},
};
